import { render, staticRenderFns } from "./OtherLines.vue?vue&type=template&id=dcec6adc&scoped=true&"
import script from "./OtherLines.vue?vue&type=script&lang=ts&"
export * from "./OtherLines.vue?vue&type=script&lang=ts&"
import style0 from "./OtherLines.vue?vue&type=style&index=0&id=dcec6adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcec6adc",
  null
  
)

export default component.exports